/** Default OFO schedule version for the currently compiled index. */
export const OFO_SCHEDULE_VERSION = '2021';
export const PHRASE_OVERRIDES = {
    // Cars / vehicle mechanics → Automotive Motor Mechanic (653101)
    'fix cars': [{ code: '653101', version: OFO_SCHEDULE_VERSION, title: 'Automotive Motor Mechanic' }],
    'cars': [{ code: '653101', version: OFO_SCHEDULE_VERSION, title: 'Automotive Motor Mechanic' }],
    'car': [{ code: '653101', version: OFO_SCHEDULE_VERSION, title: 'Automotive Motor Mechanic' }],
    'vehicle mechanic': [{ code: '653101', version: OFO_SCHEDULE_VERSION, title: 'Automotive Motor Mechanic' }],
    'car mechanic': [{ code: '653101', version: OFO_SCHEDULE_VERSION, title: 'Automotive Motor Mechanic' }],
    'motor mechanic': [{ code: '653101', version: OFO_SCHEDULE_VERSION, title: 'Automotive Motor Mechanic' }],
    'automotive mechanic': [{ code: '653101', version: OFO_SCHEDULE_VERSION, title: 'Automotive Motor Mechanic' }],
    'repair cars': [{ code: '653101', version: OFO_SCHEDULE_VERSION, title: 'Automotive Motor Mechanic' }],
    'mend cars': [{ code: '653101', version: OFO_SCHEDULE_VERSION, title: 'Automotive Motor Mechanic' }],
    // Build houses → building trades (Carpenter / Bricklayer / Concreter)
    'build houses': [
        { code: '641502', version: OFO_SCHEDULE_VERSION, title: 'Carpenter' },
        { code: '641201', version: OFO_SCHEDULE_VERSION, title: 'Bricklayer' },
        { code: '641401', version: OFO_SCHEDULE_VERSION, title: 'Concreter' },
    ],
    'build a house': [
        { code: '641502', version: OFO_SCHEDULE_VERSION, title: 'Carpenter' },
        { code: '641201', version: OFO_SCHEDULE_VERSION, title: 'Bricklayer' },
        { code: '641401', version: OFO_SCHEDULE_VERSION, title: 'Concreter' },
    ],
    'build home': [
        { code: '641502', version: OFO_SCHEDULE_VERSION, title: 'Carpenter' },
        { code: '641201', version: OFO_SCHEDULE_VERSION, title: 'Bricklayer' },
        { code: '641401', version: OFO_SCHEDULE_VERSION, title: 'Concreter' },
    ],
    // Nurse → Registered Nurse family (OFO has no single "General Nurse")
    'nurse sick people': [
        { code: '222101', version: OFO_SCHEDULE_VERSION, title: 'Clinical Nurse Practitioner' },
        { code: '222102', version: OFO_SCHEDULE_VERSION, title: 'Aged Care Registered Nurse' },
        { code: '222103', version: OFO_SCHEDULE_VERSION, title: 'Registered Nurse (Child and Family Health)' },
        { code: '222104', version: OFO_SCHEDULE_VERSION, title: 'Registered Nurse (Community Health)' },
        { code: '222105', version: OFO_SCHEDULE_VERSION, title: 'Registered Nurse (Critical Care and Emergency)' },
        { code: '222106', version: OFO_SCHEDULE_VERSION, title: 'Registered Nurse (Developmental Disability)' },
    ],
    'nurse sick': [
        { code: '222101', version: OFO_SCHEDULE_VERSION, title: 'Clinical Nurse Practitioner' },
        { code: '222102', version: OFO_SCHEDULE_VERSION, title: 'Aged Care Registered Nurse' },
        { code: '222103', version: OFO_SCHEDULE_VERSION, title: 'Registered Nurse (Child and Family Health)' },
        { code: '222104', version: OFO_SCHEDULE_VERSION, title: 'Registered Nurse (Community Health)' },
        { code: '222105', version: OFO_SCHEDULE_VERSION, title: 'Registered Nurse (Critical Care and Emergency)' },
        { code: '222106', version: OFO_SCHEDULE_VERSION, title: 'Registered Nurse (Developmental Disability)' },
    ],
    // Teach → school-teacher family
    'teach children': [
        { code: '233107', version: OFO_SCHEDULE_VERSION, title: 'FET Phase School Teacher (Grades 10-12)' },
        { code: '233108', version: OFO_SCHEDULE_VERSION, title: 'Senior Phase School Teacher (Grades 7 - 9)' },
        { code: '234101', version: OFO_SCHEDULE_VERSION, title: 'Foundation Phase School Teacher' },
        { code: '232131', version: OFO_SCHEDULE_VERSION, title: 'Adult Education Teacher' },
    ],
    'teach kids': [
        { code: '233107', version: OFO_SCHEDULE_VERSION, title: 'FET Phase School Teacher (Grades 10-12)' },
        { code: '233108', version: OFO_SCHEDULE_VERSION, title: 'Senior Phase School Teacher (Grades 7 - 9)' },
        { code: '234101', version: OFO_SCHEDULE_VERSION, title: 'Foundation Phase School Teacher' },
        { code: '232131', version: OFO_SCHEDULE_VERSION, title: 'Adult Education Teacher' },
    ],
    // Cut hair → Hairdresser
    'cut hair': [{ code: '514101', version: OFO_SCHEDULE_VERSION, title: 'Hairdresser' }],
    // Drive trucks → Truck Driver (General) / Tow Truck Driver
    'drive trucks': [
        { code: '733201', version: OFO_SCHEDULE_VERSION, title: 'Truck Driver (General)' },
        { code: '733205', version: OFO_SCHEDULE_VERSION, title: 'Tow Truck Driver' },
    ],
    'drive truck': [
        { code: '733201', version: OFO_SCHEDULE_VERSION, title: 'Truck Driver (General)' },
        { code: '733205', version: OFO_SCHEDULE_VERSION, title: 'Tow Truck Driver' },
    ],
    // Cook food → Cook / Chef / Fast Food Cook
    'cook food': [
        { code: '512101', version: OFO_SCHEDULE_VERSION, title: 'Cook' },
        { code: '343401', version: OFO_SCHEDULE_VERSION, title: 'Chef' },
        { code: '841101', version: OFO_SCHEDULE_VERSION, title: 'Fast Food Cook' },
    ],
    // Weld metal → Welder family
    'weld metal': [
        { code: '651202', version: OFO_SCHEDULE_VERSION, title: 'Welder' },
        { code: '651201', version: OFO_SCHEDULE_VERSION, title: 'Pressure Welder' },
        { code: '651203', version: OFO_SCHEDULE_VERSION, title: 'Fitter-welder' },
    ],
    // Bursar → finance roles (OFO has no "Bursar")
    'i am a bursar': [
        { code: '121101', version: OFO_SCHEDULE_VERSION, title: 'Finance Manager' },
        { code: '241102', version: OFO_SCHEDULE_VERSION, title: 'Management Accountant' },
    ],
    'bursar': [
        { code: '121101', version: OFO_SCHEDULE_VERSION, title: 'Finance Manager' },
        { code: '241102', version: OFO_SCHEDULE_VERSION, title: 'Management Accountant' },
    ],
    // Casual/contractor phrases job-seekers type — pin canonical trade code.
    'general worker': [{ code: '831301', version: OFO_SCHEDULE_VERSION, title: "Builder's Worker" }],
    'labourer': [{ code: '831301', version: OFO_SCHEDULE_VERSION, title: "Builder's Worker" }],
    'caregiver': [{ code: '515301', version: OFO_SCHEDULE_VERSION, title: 'Caretaker' }],
    'carers': [{ code: '515301', version: OFO_SCHEDULE_VERSION, title: 'Caretaker' }],
    'admin clerk': [{ code: '411101', version: OFO_SCHEDULE_VERSION, title: 'General Clerk' }],
    'instrumentation technician': [{ code: '672105', version: OFO_SCHEDULE_VERSION, title: 'Instrument Mechanician' }],
    'auto electrician': [{ code: '671101', version: OFO_SCHEDULE_VERSION, title: 'Electrician' }],
    'code 14 driver': [{ code: '733201', version: OFO_SCHEDULE_VERSION, title: 'Truck Driver (General)' }],
    'catering assistant': [{ code: '841201', version: OFO_SCHEDULE_VERSION, title: 'Kitchenhand' }],
    'kitchen assistant': [{ code: '841201', version: OFO_SCHEDULE_VERSION, title: 'Kitchenhand' }],
    'dishwasher': [{ code: '841201', version: OFO_SCHEDULE_VERSION, title: 'Kitchenhand' }],
    'car wash': [{ code: '811101', version: OFO_SCHEDULE_VERSION, title: 'Domestic Cleaner' }],
    'social media manager': [{ code: '122201', version: OFO_SCHEDULE_VERSION, title: 'Advertising and Public Relations Manager' }],
    // Security phrasing — OFO has no "Bodyguard"/"Bouncer"; map to Security Officer.
    'bodyguard': [{ code: '541401', version: OFO_SCHEDULE_VERSION, title: 'Security Officer' }],
    'bouncer': [{ code: '541401', version: OFO_SCHEDULE_VERSION, title: 'Security Officer' }],
    'doorman': [{ code: '541401', version: OFO_SCHEDULE_VERSION, title: 'Security Officer' }],
    // Cashier — surface the everyday store/office cashier (523102) and bank teller
    // (421101) above senior retail/managerial roles that BM25 ties on "cashier".
    'cashier': [
        { code: '523102', version: OFO_SCHEDULE_VERSION, title: 'Office Cashier' },
        { code: '421101', version: OFO_SCHEDULE_VERSION, title: 'Bank Teller' },
    ],
    'store cashier': [{ code: '523102', version: OFO_SCHEDULE_VERSION, title: 'Office Cashier' }],
    // Network engineer — people usually mean the computer network role (252301),
    // and often omit "computer"; pin it above the telecommunications variant.
    'network engineer': [
        { code: '252301', version: OFO_SCHEDULE_VERSION, title: 'Computer Network and Systems Engineer' },
        { code: '351301', version: OFO_SCHEDULE_VERSION, title: 'Computer Network Technician' },
    ],
    'computer network': [
        { code: '252301', version: OFO_SCHEDULE_VERSION, title: 'Computer Network and Systems Engineer' },
        { code: '351301', version: OFO_SCHEDULE_VERSION, title: 'Computer Network Technician' },
    ],
};
const STOPWORDS = new Set([
    'a', 'an', 'the', 'i', 'am', 'are', 'is', 'to', 'for', 'of', 'my', 'me',
    'do', 'does', 'did', 'want', 'need', 'looking', 'work', 'as', 'be', 'in', 'on',
]);
export function normalizePhrase(query) {
    return query
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, ' ')
        .split(/\s+/)
        .filter((t) => t.length > 0 && !STOPWORDS.has(t))
        .join(' ');
}
/** Resolve a query to its pinned override codes (empty array if none). */
export function phraseOverride(query) {
    const key = normalizePhrase(query);
    const refs = PHRASE_OVERRIDES[key];
    return refs ? refs.map((r) => r.code) : [];
}
/** Resolve a query to its full pinned overrides (code + version + title). */
export function phraseOverrideRefs(query) {
    const key = normalizePhrase(query);
    return PHRASE_OVERRIDES[key] ?? [];
}
//# sourceMappingURL=overrides.js.map